/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TicketResponseDto { 
    id?: number;
    ticketId?: number;
    guid?: string;
    creationTime?: string;
    totalAmount?: number;
    gatewayTransactionId?: string | null;
    gatewayResponse?: string | null;
    gatewayResponseCode?: string | null;
    isSuccess?: boolean;
}

